import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/lib/supabase';

export interface MessageRecord {
  id: string;
  template_name: string | null;
  content: string;
  variables: string[];
  created_at: string;
}

export function useMessages() {
  const [messages, setMessages] = useState<MessageRecord[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchMessages = useCallback(async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from('ep_messages')
      .select('*')
      .order('created_at', { ascending: false });
    if (!error && data) {
      setMessages(
        data.map((row) => ({
          ...row,
          variables: Array.isArray(row.variables) ? row.variables : JSON.parse(row.variables || '[]'),
        }))
      );
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchMessages();
  }, [fetchMessages]);

  const addMessage = async (template_name: string | null, content: string, variables: string[]) => {
    const { data, error } = await supabase
      .from('ep_messages')
      .insert({ template_name, content, variables })
      .select()
      .single();
    if (!error && data) {
      const rec: MessageRecord = {
        ...data,
        variables: Array.isArray(data.variables) ? data.variables : [],
      };
      setMessages((prev) => [rec, ...prev]);
      return rec;
    }
    return null;
  };

  const deleteMessage = async (id: string) => {
    const { error } = await supabase.from('ep_messages').delete().eq('id', id);
    if (!error) setMessages((prev) => prev.filter((m) => m.id !== id));
    return !error;
  };

  return { messages, loading, addMessage, deleteMessage, refetch: fetchMessages };
}